module.exports = __webpack_public_path__ + "img/photo-10.0e8a0683.jpg";